
export default {
	state: {
		history: [],
	},

	mutations: {
		pushToSidebarHistory(state, sidebarData) {
			state.history.push(JSON.stringify(sidebarData));
		},

		popFromSidebarHistory(state) {
			state.history.pop();
		},

		updateImageInHistory(state, data) {
			state.history = state.history.map((item) => {
				const sidebar = JSON.parse(item);

				if (sidebar.outputData.key === data.key) {
					sidebar.outputData.value = data.value;
				}
				return JSON.stringify(sidebar);
			});
		},
	},

	actions: {
		pushToSidebarHistory({ commit }, sidebarData) {
			return new Promise((resolve) => {
				commit('pushToSidebarHistory', sidebarData);
				resolve();
			});
		},

		popFromSidebarHistory({ commit }) {
			commit('popFromSidebarHistory');
		},

		updateImageInHistory({ commit }, data) {
			commit('updateImageInHistory', data);
		},

	},

	getters: {
		peekFromSidebarHistory(state) {
			const length = state.history.length;
			if (length > 0) return JSON.parse(state.history[length - 1]);
			return null;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/modules/sidebarhistory.js